/**
 * Access Restricted Component
 *
 * Displayed when a user tries to access an owner-only settings page.
 */

import { ShieldAlert } from 'lucide-react';

interface AccessRestrictedProps {
  title?: string;
  description?: string;
}

export function AccessRestricted({
  title = 'Access Restricted',
  description = 'Only workspace owners can access this page. Contact your workspace owner for assistance.',
}: AccessRestrictedProps) {
  return (
    <div className="flex h-full flex-col items-center justify-center py-12">
      <ShieldAlert className="mb-4 h-12 w-12 text-muted-foreground" />
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="mt-2 max-w-md text-center text-muted-foreground">
        {description}
      </p>
    </div>
  );
}
